import * as React from "react";
import { SnapshotCollectionsOutcomesExport } from "@/modules/snapshots/snapshotCollections/components/outcomes/exportOutcomes";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import type { SnapshotViewConfiguration } from "@/modules/snapshots/snapshotViews.types";

interface Props {
  snapshotCollection: SnapshotCollection;
  filteredOutcomeIds?: string[];
  subcollectionId?: string;
  subcollectionName?: string;
  disabled?: boolean;
  disabledReason?: string;
  contractFamilyProjection?: boolean;
  snapshotViewId?: string;
  snapshotViewConfiguration?: SnapshotViewConfiguration;
}

export const SnapshotGridButtons: React.FC<Props> = ({
  snapshotCollection,
  filteredOutcomeIds,
  subcollectionId,
  subcollectionName,
  disabled = false,
  disabledReason,
  contractFamilyProjection = false,
  snapshotViewId,
  snapshotViewConfiguration,
}) => (
  <div className="flex" title={disabled ? disabledReason : undefined}>
    {!!snapshotCollection && (
      <SnapshotCollectionsOutcomesExport
        size="sm"
        label="Export"
        snapshotCollection={snapshotCollection}
        filteredOutcomeIds={filteredOutcomeIds}
        subcollectionId={subcollectionId}
        subcollectionName={subcollectionName}
        className="h-9"
        disabled={disabled}
        contractFamilyProjection={contractFamilyProjection}
        snapshotViewId={snapshotViewId}
        snapshotViewConfiguration={snapshotViewConfiguration}
      />
    )}
  </div>
);
